
//#region Environment

//#region Users
class Profile {
    static readonly _ = 'Environment.Feature.User.Profile';
    static readonly Vat = 'Environment.Feature.User.Profile.Vat';
}

class User {
    static readonly _ = 'Environment.Feature.User';
    static readonly CreateAdminUser = 'Environment.Feature.User.CreateAdminUser';
    static readonly CreateAppUser = 'Environment.Feature.User.CreateAppUser';
    static readonly CreateEndUser = 'Environment.Feature.User.CreateEndUser';
    static readonly ApiLogin = 'Environment.Feature.User.ApiLogin';
    static readonly LinkAccount = 'Environment.Feature.User.LinkAccount';

    static readonly UserSelfRegistration = 'Environment.Feature.User.SelfRegistration';
    static readonly MaxAmountOfUser = 'Environment.Feature.User.MaxAmountOfUser';

    static get Profile(): typeof Profile {
        return Profile;
    }
}
//#endregion Users


//#region Tenant
class Subtenant {
    static readonly _ = 'Environment.Feature.Tenants.Subtenant';
    static readonly SubtenantMaxAmountOfSubTenants = 'Environment.Feature.Tenants.Subtenant.MaxAmountOfSubTenants';
    static readonly SubtenantDefaultEdition = 'Environment.Feature.Tenants.Subtenant.DefaultEdition';
}

class TenantSettings {
    static readonly _ = 'Environment.Feature.Tenants.Settings';
    static readonly Security = 'Environment.Feature.Tenants.Settings.Security';
    static readonly Invoice = 'Environment.Feature.Tenants.Settings.Invoice';
    static readonly UserManagement = 'Environment.Feature.Tenants.Settings.UserManagement';
}

class Tenant {
    static readonly _ = 'Environment.Feature.Tenants';
    static readonly ShowTenant = 'Environment.Feature.Tenants.ShowTenant';
    static readonly TenantsSelfRegistration = 'Environment.Feature.Tenants.SelfRegistration';
    static readonly TenantsUseCustomTenantName = 'Environment.Feature.Tenants.UseCustomTenantName';
    static readonly Branding = 'Environment.Feature.Tenants.Branding';

    static get Settings(): typeof TenantSettings {
        return TenantSettings;
    }
    static get Subtenant(): typeof Subtenant {
        return Subtenant;
    }
}
//#endregion Tenant

//#region Roles
class Roles {
    static readonly _ = 'Environment.Feature.Roles';
}
//#endregion Roles

//#region OrganizationUnit

class OrganizationUnit {
    static readonly _ = 'Environment.Feature.OrganizationUnit';
}

//#endregion OrganizationUnit

//#region Registration

class Registration {
    static readonly _ = 'Environment.Feature.Registration';
    static readonly RedirectProfile = 'Environment.Feature.Registration.RedirectProfile';
}

//#endregion Registration



//#region BookingModule

class BookingModule {
    static readonly _ = 'Environment.Feature.BookingModule';
    static readonly Assignments = 'Environment.Feature.BookingModule.Assignments';
    static readonly Bookings = 'Environment.Feature.BookingModule.Bookings';
    static readonly Hours = 'Environment.Feature.BookingModule.Hours';
    static readonly Customers = 'Environment.Feature.BookingModule.Customers';
    static readonly Invoices = 'Environment.Feature.BookingModule.Invoices';
    static readonly ExtendedRemark = 'Environment.Feature.BookingModule.ExtendedRemark';
}

//#endregion BookingModule

//#region BankModule

class BankModule {

    static readonly _ = 'Environment.Feature.BankModule';
    static readonly Dashboard = 'Environment.Feature.BankModule.Dashboard';
    static readonly BankAccountsOverview = 'Environment.Feature.BankModule.BankAccountsOverview';
    static readonly Balance = 'Environment.Feature.BankModule.Balance';
    static readonly RC = 'Environment.Feature.BankModule.RC';

    static readonly Accounting = 'Environment.Feature.BankModule.Accounting';
    static readonly DefaultAccountPrepayment = 'Environment.Feature.BankModule.DefaultAccountPrepayment';
    static readonly DefaultTaxReservation = 'Environment.Feature.BankModule.DefaultTaxReservation';
    static readonly DefaultTransactionFee = 'Environment.Feature.BankModule.DefaultTransactionFee';
}
//#endregion BankModule

//#endregion BookingModule


//#region Billing
class Billing {
    static readonly _ = 'Environment.Feature.Billing';
    static get PaymentTerms(): typeof PaymentTerms {
        return PaymentTerms;
    }
}

class PaymentTerms {
    static readonly _ = 'Environment.Feature.Billing.PaymentTerms';
    static readonly AdministrationInheritance = 'Environment.Feature.Billing.PaymentTerms.AdministrationInheritance';
    static readonly MargeInvoice = 'Environment.Feature.Billing.PaymentTerms.MargeInvoice';
    static readonly Master = 'Environment.Feature.Billing.PaymentTerms.Master';
    static readonly TermsMandatoryInheritance = 'Environment.Feature.Billing.PaymentTerms.TermsMandatoryInheritance';

}
//#endregion Billing


//#region Administration

class Administration {
    static readonly _ = 'Environment.Feature.Administration';
    static readonly Edition = 'Environment.Feature.Administration.Edition';
    static readonly Language = 'Environment.Feature.Administration.Language';

    static get Settings(): typeof AdministrationSettings {
        return AdministrationSettings;
    }
}

//#region AdministrationSettings

class AdministrationSettings {
    static readonly _ = 'Environment.Feature.Administration.Settings';
    static readonly ShowInMenu = 'Environment.Feature.Administration.Settings.ShowInMenu';
}
//#endregion AdministrationSettings

//#endregion Administration
class Environment {

    static readonly _ = 'Environment.Feature';

    static get Administration(): typeof Administration {
        return Administration;
    }
    static get Roles(): typeof Roles {
        return Roles;
    }
    static get User(): typeof User {
        return User;
    }
    static get Tenant(): typeof Tenant {
        return Tenant;
    }
    static get OrganizationUnit(): typeof OrganizationUnit {
        return OrganizationUnit;
    }
    static get Registration(): typeof Registration {
        return Registration;
    }
    static get BookingModule(): typeof BookingModule {
        return BookingModule;
    }
    static get BankModule(): typeof BankModule {
        return BankModule;
    }
    static get Billing(): typeof Billing {
        return Billing;
    }
}

//#endregion Environment


//#region Plattform

class Tax {
    static readonly _ = 'App.Feature.Plattform.Tax';
    static readonly TaxExtended = 'App.Feature.Plattform.Tax.Extended';

    /// <summary>
    /// Tax feature from plattform
    /// </summary>
    static readonly GLA = 'App.Feature.Plattform.Tax.GLA';
}

class Plattform {
    static readonly _ = 'App.Feature.Plattform';

    static get Tax(): typeof Tax {
        return Tax;
    }

    static readonly ClientFeature = 'App.Feature.Plattform.Clients';
}


//#endregion Plattform

//#region App

//#region Document

class Documents {
    static readonly _ = 'App.Documents';
    static readonly Archive = 'App.Documents.Archive';
    static readonly BankImport = 'App.Documents.BankImport';
    static readonly New = 'App.Documents.New';
    static readonly Queue = 'App.Documents.Queue';
    static readonly ShowHistory = 'App.Documents.ShowHistory';
    static get Pipeline(): typeof Pipeline {
        return Pipeline;
    }
}

class Pipeline {
    static readonly _ = 'App.Documents.Pipeline';
    static readonly Name = 'App.Documents.Pipeline.Name';
    static readonly ReturnChannel = 'App.Documents.Pipeline.ReturnChannel';
    static readonly UserName = 'App.Documents.Pipeline.UserName';
    static readonly Token = 'App.Documents.Pipeline.Token';
}

//#endregion Document

//#region RegistrationLogger
class RegistrationLogger {
    static readonly _ = 'App.Feature.RegistrationLogger';
    static readonly RetentionTime = 'App.Feature.RegistrationLogger.RetentionTime';
}
//#endregion RegistrationLogger


//#region Subscription
class Subscription {
    static readonly _ = 'App.Subscription';
    static get SubscriptionDocument(): typeof SubscriptionDocument {
        return SubscriptionDocument;
    }
}

class SubscriptionDocument {
    static readonly _ = 'App.Subscription.Document';
    static get SubscriptionBilling(): typeof SubscriptionBilling {
        return SubscriptionBilling;
    }
    static get Rating(): typeof Rating {
        return Rating;
    }
    static get Validate(): typeof Validate {
        return Validate;
    }
}

class SubscriptionBilling {
    static readonly _ = 'App.Subscription.Document.Billing';
    static readonly IncludedSeconds = 'App.Subscription.Document.Billing.IncludedSeconds';
    static readonly PricePerSecond = 'App.Subscription.Document.Billing.PricePerSecond';
    static readonly RollOver = 'App.Subscription.Document.Billing.RollOver';
}

class Rating {
    static readonly _ = 'App.Subscription.Document.Rating';
    static readonly MaxDocSize = 'App.Subscription.Document.Rating.MaxDocSize';
    static readonly MaxUploadRate = 'App.Subscription.Document.Rating.MaxUploadRate';
    static readonly PeriodUploadRate = 'App.Subscription.Document.Rating.PeriodUploadRate';
}

class Validate {
    static readonly _ = 'App.Subscription.Document.Validate';
    static readonly CustomFields = 'App.Subscription.Document.Validate.CustomFields';
    static readonly MandatoryFields = 'App.Subscription.Document.Validate.MandatoryFields';
    static readonly Tax = 'App.Subscription.Document.Validate.Tax';
}
//#endregion Subscription


//#region Ublion
class Ublion {
    static readonly _ = 'App.Ublion';
    static readonly TaxGeneration = 'App.Ublion.TaxGeneration';
}
//#endregion Ublion


class App {

    static readonly _ = 'App.Feature';
    static readonly AppStore = 'App.Feature.AppStore';
    static readonly BankImport = 'App.Feature.BankImport';
    static readonly CustomLinks = 'App.Feature.CustomLinks';
    static readonly VDB = 'App.Feature.VDB';
    static readonly AppMode = 'App.Mode';
    static readonly Backorder = 'App.Feature.Webshop.Backorder';

    static get Ublion(): typeof Ublion {
        return Ublion;
    }

    static get Documents(): typeof Documents {
        return Documents;
    }

    static get RegistrationLogger(): typeof RegistrationLogger {
        return RegistrationLogger;
    }
}

//#endregion App

//#region Webshop
class Webshop {
    static readonly _ = 'App.Feature.Webshop';
    static readonly FavoriteArticles = 'App.Feature.Webshop.FavoriteArticles';
}
//#endregion Webshop


export class FeatureDefinition {
    static readonly project = 'App.Project';

    static get Environment(): typeof Environment {
        return Environment;
    }
    static get Plattform(): typeof Plattform {
        return Plattform;
    }
    static get App(): typeof App {
        return App;
    }
    static get Webshop(): typeof Webshop {
        return Webshop;
    }

    static readonly bankImport = 'App.Plattform.BankImport';
    static readonly bankAccountOverview = 'Environment.Feature.BankModule.BankAccountsOverview';
    static readonly clients = 'App.Plattform.Clients';
    static readonly ublion = 'App.Documents';
}


